<template>
  <div class="inner-graph-content">
    <div :class="['home-care-note-book', listTabHomeCareHaveData.length == 0 ? 'pt-4' : '']">
      <div class="home-care-content-area">
        <div v-if="isDataLoadingFirstTime" class="text-center">
          <img style="height:100px margin: 25px 0" src="/common/img/loading.gif"/>
        </div>
        <div v-else-if="listTabHomeCareHaveData.length == 0" class="detail-content-area">
          <div class="not-found-data">
            データがありません
          </div>
        </div>
        <template v-else>
          <template v-for="(data, id, index) in list6TopTable">
            <div v-if="listTabHomeCareHaveData.includes(id)" :id="id" class="detail-content-area" :key="id+index">
              <h3>{{data.title}}</h3>
              <div v-if="!isDataLoaded[id]" class="text-center">
                <img style="height:100px margin: 25px 0" src="/common/img/loading.gif"/>
              </div>
              <div v-else-if="dataTabFormatted[id].isHaveData == false " class="not-found-data">
                データがありません
              </div>
              <template v-else>
                <div class="list-time-area">
                  <ul>
                    <li v-if="dataTabFormatted[id].back" @click="getDataTab(id, 'search_left', dataTabFormatted[id].answer_date_time)">
                      <a><span class="icon-left-arrow"></span></a>
                    </li>
                    <li class="pl-3 pr-3">更新日：{{dataTabFormatted[id].date}}</li>
                    <li v-if="dataTabFormatted[id].next" @click="getDataTab(id, 'search_right', dataTabFormatted[id].answer_date_time)">
                      <a><span  class="icon-right-arrow"></span></a>
                    </li>
                  </ul>
                </div>
                <div class="home-care-table">
                  <table>
                    <tr v-for="(row, rowIndex) in data.table" :key="id+rowIndex">
                      <template v-for="(value, name, rowDataIndex) in row">
                        <td :key="id+'-'+rowIndex+'-'+rowDataIndex+'-0'">{{value}}</td>
                        <td 
                          :colspan="Object.keys(row).length == 1 ? 3 : 1"
                          :key="id+'-'+rowIndex+'-'+rowDataIndex+'-1'"
                        >
                          {{
                            (dataTabFormatted[id][name] || dataTabFormatted[id][name] == 0 ) ?
                            ((name === 'start_time' || name === 'end_time') ? dataTabFormatted[id][name] + '時' : (value.includes('插入長(mm)') ? convertCalculateUnit(dataTabFormatted[id][name], '*') : (value.includes('吸引深さ制限(cm)') ? convertCalculateUnit(dataTabFormatted[id][name], '/') : dataTabFormatted[id][name])) ) : 
                            'ー'
                          }}
                        </td>
                      </template>
                    </tr>
                  </table>
                  <div class="table-image-area">
                    <div class="title-list-image border-top-0">画像</div>
                    <div :class="['list-image', dataTabFormatted[id]['attach_images_'+id] != null ? 'have-image' : '']">
                      <p v-if="dataTabFormatted[id]['attach_images_'+id] == null">画像のデータがありません</p>
                      <ul v-else>
                        <li 
                          v-for="(img_url, index) in dataTabFormatted[id]['attach_images_'+id]"
                          @click="openModalListImage(dataTabFormatted[id]['attach_images_'+id], index)"
                          :key="id+'_img_'+index"
                        >
                          <img v-lazy="img_url" height="300"/>
                        </li>
                      </ul>
                    </div>
                  </div>
                </div>
              </template>
            </div>
          </template>
          <div v-if="listTabHomeCareHaveData.includes('ventilator')" id="ventilator" class="detail-content-area">
            <h3>人工呼吸器</h3>
            <div v-if="!isDataLoaded['ventilator']" class="text-center">
              <img style="height:100px margin: 25px 0" src="/common/img/loading.gif"/>
            </div>
            <div v-else-if="dataTabFormatted.ventilator.isHaveData == false " class="not-found-data">
              データがありません
            </div>
            <template v-else>
              <div class="list-time-area">
                <ul>
                  <li v-if="dataTabFormatted.ventilator.back" @click="getDataTab('ventilator', 'search_left', dataTabFormatted.ventilator.answer_date_time)">
                    <a><span class="icon-left-arrow"></span></a>
                  </li>
                  <li class="pl-3 pr-3">更新日：{{dataTabFormatted.ventilator.date}}</li>
                  <li v-if="dataTabFormatted.ventilator.next" @click="getDataTab('ventilator', 'search_right', dataTabFormatted.ventilator.answer_date_time)">
                    <a><span  class="icon-right-arrow"></span></a>
                  </li>
                </ul>
              </div>
              <div class="home-care-table">
                <table>
                  <tr>
                    <td>製品名</td>
                    <td colspan="3">{{dataTabFormatted.ventilator.product_name_ventilator}}</td>
                  </tr>
                </table>
                <div v-for="(value, name, i) in listVentilatorTabImg" class="table-image-area" :key="name+i">
                  <div class="title-list-image border-top-0">{{value}}</div>
                  <div :class="['list-image', dataTabFormatted.ventilator[name] != null ? 'have-image' : '']">
                    <p v-if="dataTabFormatted.ventilator[name] == null">画像のデータがありません</p>
                    <ul v-else>
                      <li
                        v-for="(img_url, index) in dataTabFormatted.ventilator[name]"
                        @click="openModalListImage(dataTabFormatted.ventilator[name], index)"
                        :key="'ventilator_'+name+'_'+index"
                      >
                        <img v-lazy="img_url" height="300"/>
                      </li>
                    </ul>
                  </div>
                </div>
              </div>
            </template>
          </div>
          <div v-if="listTabHomeCareHaveData.includes('insulin')" id="insulin" class="detail-content-area">
            <h3>インスリン</h3>
            <div v-if="!isDataLoaded['insulin']" class="text-center">
              <img style="height:100px margin: 25px 0" src="/common/img/loading.gif"/>
            </div>
            <div v-else-if="dataTabFormatted.insulin.isHaveData == false " class="not-found-data">
              データがありません
            </div>
            <template v-else>
              <div class="list-time-area">
                <ul>
                  <li v-if="dataTabFormatted.insulin.back" @click="getDataTab('insulin', 'search_left', dataTabFormatted.insulin.answer_date_time)">
                    <a><span class="icon-left-arrow"></span></a>
                  </li>
                  <li class="pl-3 pr-3">更新日：{{dataTabFormatted.insulin.date}}</li>
                  <li v-if="dataTabFormatted.insulin.next" @click="getDataTab('insulin', 'search_right', dataTabFormatted.insulin.answer_date_time)">
                    <a><span  class="icon-right-arrow"></span></a>
                  </li>
                </ul>
              </div>
              <div class="home-care-table">
                <div class="table-image-area">
                  <div class="title-list-image">インスリン製剤</div>
                  <div :class="['list-image border-bottom-0', dataTabFormatted.insulin.attach_images_insulin_formulation != null ? 'have-image' : '']">
                    <p v-if="dataTabFormatted.insulin.attach_images_insulin_formulation == null">画像のデータがありません</p>
                    <ul v-else>
                      <li 
                        v-for="(img_url, index) in dataTabFormatted.insulin.attach_images_insulin_formulation"
                        @click="openModalListImage(dataTabFormatted.insulin.attach_images_insulin_formulation, index)"
                        :key="'insulin_img_'+index"
                      >
                        <img v-lazy="img_url" height="300"/>
                      </li>
                    </ul>
                  </div>
                </div>
                <table>
                  <tr>
                    <td>投与経路</td>
                    <td colspan="3">{{dataTabFormatted.insulin.route_through_insulin || 'ー'}}</td>
                  </tr>
                  <template v-if="dataTabFormatted.insulin.route_through_insulin === 'ペン型(基本)'">
                    <tr v-for="(row, rowIndex) in listInsulinTitleTable.type_basic" :key="'insulin_basic_'+rowIndex">
                      <template v-if="Object.keys(row).length == 1">
                        <td>{{`${row.administration_time_other_basic}(${getInsulinUnit(dataTabFormatted.insulin.administration_time_other_basic, 0)})`}}</td>
                        <td colspan="3">{{getInsulinUnit(dataTabFormatted.insulin.administration_time_other_basic, 1)}}</td>
                      </template>
                      <template v-else v-for="(value, name, rowDataIndex) in row">
                        <td :key="'insulin_basic_'+rowIndex+'_'+rowDataIndex+'_0'">{{value}}</td>
                        <td :key="'insulin_basic'+rowIndex+'_'+rowDataIndex+'_1'">{{getInsulinUnit(dataTabFormatted.insulin[name])}}</td>
                      </template>
                    </tr>
                  </template>
                  <template v-if="dataTabFormatted.insulin.route_through_insulin === 'ペン型(スケール)'">
                    <template v-for="(value, name, index) in listInsulinTitleTable.type_scale">
                      <tr :key="'insulin_scale_'+index+'_0'">
                        <td colspan="4">{{value}}</td>
                      </tr>
                      <template v-if="value === '投与時間'">
                        <tr :key="'insulin_scale_'+index+'_1'">
                          <td>
                            {{`${value}(${getInsulinUnit(dataTabFormatted.insulin.administration_time_other_scale, 0)})`}}
                          </td>
                          <td colspan="3">{{getInsulinUnit(dataTabFormatted.insulin.administration_time_other_scale, 1)}}</td>
                        </tr>
                      </template>
                      <template v-else>
                        <tr :key="'insulin_scale_'+index+'_1'">
                          <td>80mg/dl以下</td>
                          <td>{{getInsulinUnit(dataTabFormatted.insulin[name][0])}}</td>
                          <td>81mg/dl 〜 199mg/dl</td>
                          <td>{{getInsulinUnit(dataTabFormatted.insulin[name][1])}}</td>
                        </tr>
                        <tr :key="'insulin_scale_'+index+'_2'">
                          <td>200mg/dl 〜 349mg/dl</td>
                          <td>{{getInsulinUnit(dataTabFormatted.insulin[name][2])}}</td>
                          <td>350mg/dl 〜 449mg/dl</td>
                          <td>{{getInsulinUnit(dataTabFormatted.insulin[name][3])}}</td>
                        </tr>
                        <tr :key="'insulin_scale_'+index+'_3'">
                          <td>450mg/dl以上</td>
                          <td colspan="3">{{getInsulinUnit(dataTabFormatted.insulin[name][4])}}</td>
                        </tr>
                      </template>
                    </template>
                  </template>
                </table>
                <div class="table-image-area" v-if="dataTabFormatted.insulin.route_through_insulin === 'インスリンポンプ(持続)'">
                  <div class="title-list-image border-top-0">インスリンポンプ(持続)</div>
                  <div :class="['list-image', dataTabFormatted.insulin.attach_images_insulin_pump != null ? 'have-image' : '']">
                    <p v-if="dataTabFormatted.insulin.attach_images_insulin_pump == null">画像のデータがありません</p>
                    <ul v-else>
                      <li
                        v-for="(img_url, index) in dataTabFormatted.insulin.attach_images_insulin_pump"
                        @click="openModalListImage(dataTabFormatted.insulin.attach_images_insulin_pump, index)"
                        :key="'insulin_pump_img_'+index"
                      >
                        <img v-lazy="img_url" height="300"/>
                      </li>
                    </ul>
                  </div>
                </div>
              </div>
            </template>
          </div>
        </template>
      </div>
    </div>
    <b-modal id="list-image-home-care" centered :hide-header="true" :hide-footer="true" class="modal-content">
      <div class="modal-inner">
        <div class="close-icon modal-close" @click="closeModalListImage()"></div>
        <div class="modal-list-image-area">
          <b-carousel
            id="carousel-home-care-image"
            :interval="0"
            v-model="slide"
            :controls="dataPopup.length > 1 ? true : false"
            background="#ffff"
            no-wrap
            style="text-shadow: 1px 1px 2px #333;"
            @sliding-start="onSlideStart"
            @sliding-end="onSlideEnd(slide, dataPopup.length)"
          >
            <b-carousel-slide v-for="(img_url, index) in dataPopup" :key="'modal_img_'+index">
              <img :src="img_url"/>
            </b-carousel-slide>
          </b-carousel>
        </div>
      </div>
    </b-modal>
    <b-modal id="modal-homecare-message" centered :hide-header="true" :hide-footer="true">
      <div class="modal-inner">
        <div class="modal-panel-group clearfix">
          <div class="modal-inner">
            <form action="" method="">
              <div class="modal-ttl">
                <p style="font-size: 20px">この記録は削除されました。</p>
              </div>
              <div class="modal-btn-area clearfix">
                <div class="btn-base pos-center"><a href="javascript:;" @click="$bvModal.hide('modal-homecare-message')" class="modal-close"><p>OK</p></a></div>
              </div>
            </form>
        </div>
        </div>
      </div>
    </b-modal>
  </div>
</template>
<script>

import { BModal, VBModal, BButton, BCarousel, BCarouselSlide } from 'bootstrap-vue'
import { getInfoAndBasicInfo, params, convertToJPTime, getHomecareInsulinUnit } from '@/js/commons/commons'
import { mapState, mapGetters } from 'vuex'
export default {
  directives: { BModal, VBModal, BButton, BCarousel, BCarouselSlide },
  components: {
    BModal,
    BButton,
    BCarousel,
    BCarouselSlide,
  },
  props: {
    activePage: {
      type: String,
      required: true
    },
    listTab: {
      type: Array,
      required: true
    },
    activeTab: {
      type: String,
      required: true
    },
    listTabHomeCareHaveData: {
      type: Array,
      required: true
    },
    isLoadedBasicInfo: {
      type: Boolean,
      required: true,
    },
    isExportHomecarePDF: {
      type: Boolean,
      required: true,
    },
  },
  data() {
    return {
      slide: 0,
      sliding: null,
      dataTabFormatted: {
        tube_feeding: {},
        suction: {},
        oxygen: {},
        center_nutrition: {},
        dialysis: {},
        peritoneal_dialysic: {},
        ventilator: {},
        insulin: {},
      },
      isDataLoaded: {
        tube_feeding: false,
        suction: false,
        oxygen: false,
        center_nutrition: false,
        dialysis: false,
        peritoneal_dialysic: false,
        ventilator: false,
        insulin: false
      },
      list6TopTable: {
        tube_feeding: {
          title: '経管栄養',
          table: [
            {route_through: '投与経路', product_name_tube_feeding: '製品名'},
            {size_tube_feeding: 'サイズ(Fr)', insert_length: '插入長(mm)'},
            {balloon_fixed_water: 'バルーン固定水(cc)', method_tube_feeding: '投与方法'},
            {continuous_pump: '持続ポンプ'},
            {nutrient_1: '栄養剤1', nutrient_1_concentration: '栄養剤1濃度'},
            {nutrient_2: '栄養剤2', nutrient_2_concentration: '栄養剤2濃度'},
            {nutrient_3: '栄養剤3', nutrient_3_concentration: '栄養剤3濃度'}
          ]
        },
        suction: {
          title: '吸引・気管切開',
          table: [
            {product_name_suction: '製品名', size_suction: 'サイズ(mm)'},
            {cuff: 'カフ', cuff_air: 'カフ(エアー)(ml)'},
            {suction_tube: '使用吸引チューブ(Fr)', deep_limitation: '吸引深さ制限(cm)'}
          ]
        },
        oxygen: {
          title: '酸素',
          table: [
            {device: '機種', using_method: '使用方法'},
            {mid_day_amount: '日中流量(L/分)', mid_night_amount: '夜間流量(L/分)'}
          ]
        },
        center_nutrition: {
          title: '中心静脈栄養',
          table: [
            {catheter_type: 'カテーテルの種類', base_infusion: 'ベースの輸液'},
            {size_center_nutrition: 'サイズ(Fr)', infusion_speed: '輸液速度(ml/h)'},
            {start_time: '開始時間', end_time: '終了時間'},
            {others: 'その他'}
          ]
        },
        dialysis: {
          title: '導尿',
          table: [
            {method_dialysis: '方法', catheter_1: 'カテーテル1'},
            {catheter_1_size: 'カテーテル1サイズ(Fr)', catheter_2: 'カテーテル2'},
            {catheter_2_size: 'カテーテル2サイズ(Fr)', times_per_day: '1日の回数'},
          ]
        },
        peritoneal_dialysic: {
          title: '腹膜透析',
          table: [
            {type: '種類', one_time_injection_amount: '1回注液量(mL)'},
            {number_of_cycle: 'サイクル数(回)', the_last_injection: '最終注液(mL)'}
          ]
        },
      },
      listVentilatorTabImg: {
        attach_images_setting_1: '設定1',
        attach_images_setting_2: '設定2',
        attach_images_setting_3: '設定3',
        attach_images_setting_4: '設定4',
        attach_images_circuit: '呼吸器回路',
        attach_images_humidifier: '加湿器'
      },
      listInsulinTitleTable: {
        type_basic: [
          { administration_time_morning_basic: '投与時間(朝)', administration_time_noon_basic: '投与時間(昼)' },
          {administration_time_evening_basic: '投与時間(夕)', administration_time_before_going_to_bed_basic: '投与時間(眠前)'},
          {administration_time_other_basic: '投与時間'}
        ],
        type_scale: {
          administration_time_morning_scale: '投与時間(朝)',
          administration_time_noon_scale: '投与時間(昼)',
          administration_time_afternoon_scale: '投与時間(おやつ)',
          administration_time_evening_scale: '投与時間(夕)',
          administration_time_other_scale: '投与時間'
        }
      },
      dataPopup: [],
      listTabHaveData: [],
      routeThroughTubeFeedingNeedToCheck: '胃瘻',
      isDataLoadingFirstTime: true,
      homecarePDF: {}
    }
  },
  watch: {
    async activePage() {
      if(this.isDataLoadingFirstTime && this.activePage === 'home-care-note-book') {
        for(let i = 0; i < this.listTab.length; i++) {
          await this.getDataTab(this.listTab[i], 'get_latest')
        }
        this.$emit('setListTabHomeCareHaveData', this.listTabHaveData)
        this.isDataLoadingFirstTime = false
        await this.saveDataHomecarePDF()
      }
    },
    async isExportHomecarePDF() {
      if(this.isExportHomecarePDF) {
        if(!this.isLoadedBasicInfo) {
          this.$emit('setLoading', true)
          await getInfoAndBasicInfo(this.info.id)
          this.$emit('setLoading', false)
          this.$emit('setLoadedBasicInfo', true)
        }
        this.$bvModal.hide('modal-pdf')
        this.$emit('setExportHomecarePDF', false)
        await this.$store.dispatch('homeCareBook/setHomecarePDF', this.homcarePDF)
        let routeData = this.$router.resolve({name: 'HomeCarePDF'})
        window.open(routeData.href, '_blank')
      }
    }
  },
  computed: {
    ...mapState({
      viewedHistories: state => state.patient.viewedHistories,
      info: state => state.patient.info,
      tube_feeding: state => state.homeCareBook.tube_feeding,
      suction: state => state.homeCareBook.suction,
      oxygen: state => state.homeCareBook.oxygen,
      center_nutrition: state => state.homeCareBook.center_nutrition,
      dialysis: state => state.homeCareBook.dialysis,
      peritoneal_dialysic: state => state.homeCareBook.peritoneal_dialysic,
      ventilator: state => state.homeCareBook.ventilator,
      insulin: state => state.homeCareBook.insulin,
    }),
  },
  methods: {
    async saveDataHomecarePDF() {
      let list6TableOnTheTop = {}
      let tableVentilator = this.listTabHaveData.includes('ventilator') ? {title: '人工呼吸器', table: this.listVentilatorTabImg} : {}
      let tableInsulin = {title: 'インスリン', table: this.listInsulinTitleTable}
      Object.keys(this.list6TopTable).forEach( tableName => {
        if(this.listTabHaveData.includes(tableName)) {
          list6TableOnTheTop[tableName] = this.list6TopTable[tableName]
        }
      })
      this.homcarePDF = {
        dataTabFormatted: {...this.dataTabFormatted},
        list6TableOnTheTop: list6TableOnTheTop,
        tableVentilator: tableVentilator,
        tableInsulin: tableInsulin,
        child_name: this.$store.state.auth.typeOfUser !== 'pharmacy' ? this.info.name : this.viewedHistories.find((o) => { return o["child_id"] === this.$route.params.childId }).name
      }
    },
    formatTubeFeedingTable() {
      if(this.dataTabFormatted.tube_feeding && (this.dataTabFormatted.tube_feeding.route_through === this.routeThroughTubeFeedingNeedToCheck || this.dataTabFormatted.tube_feeding.route_through == null)) {
        this.list6TopTable.tube_feeding.table = [
          {route_through: '投与経路', product_name_tube_feeding: '製品名'},
          {size_tube_feeding: 'サイズ(Fr)', insert_length: '插入長(mm)'},
          {balloon_fixed_water: 'バルーン固定水(cc)', method_tube_feeding: '投与方法'},
          {continuous_pump: '持続ポンプ'},
          {nutrient_1: '栄養剤1', nutrient_1_concentration: '栄養剤1濃度'},
          {nutrient_2: '栄養剤2', nutrient_2_concentration: '栄養剤2濃度'},
          {nutrient_3: '栄養剤3', nutrient_3_concentration: '栄養剤3濃度'}
        ]
      }
      else {
        this.list6TopTable.tube_feeding.table = [
          {route_through: '投与経路', product_name_tube_feeding: '製品名'},
          {size_tube_feeding: 'サイズ(Fr)', insert_length: '插入長(mm)'},
          {nutrient_1: '栄養剤1', nutrient_1_concentration: '栄養剤1濃度'},
          {nutrient_2: '栄養剤2', nutrient_2_concentration: '栄養剤2濃度'},
          {nutrient_3: '栄養剤3', nutrient_3_concentration: '栄養剤3濃度'}
        ]
      }
    },
    async getDataTab(tab, action, time = null) {
      this.isDataLoaded[tab] = false
      await this.$store.dispatch("homeCareBook/getHomeCareInfo", { params: params('home_care_book', tab, action, this.info.id, time) })
        .then(res => {
          this.isDataLoaded[tab] = true
          let newDataFormatted = this.formatDataTab(tab)
          if(!newDataFormatted.isHaveData && (action === 'search_left' || action === 'search_right')) {
            if(newDataFormatted.isEmpty) {
              this.dataTabFormatted[tab] = {
                back: false,
                isHaveData: false,
                next: false
              }
              let self = this
              let newActiveTab = ''
              this.listTabHaveData = this.listTabHaveData.filter(function(t, index) {
                if(t === tab) {
                  if(self.listTabHaveData.length <= 1) newActiveTab = ''
                  else if (index < self.listTabHaveData.length -1) newActiveTab = self.listTabHaveData[index+1]
                  else newActiveTab = self.listTabHaveData[index-1]
                }
                return t !== tab 
              })
              this.$bvModal.show('modal-homecare-message')
              this.$emit('setActiveHomeCareTab', newActiveTab)
              this.$emit('setListTabHomeCareHaveData', this.listTabHaveData)
            }
            else {
              this.$bvModal.show('modal-homecare-message')
              this.dataTabFormatted[tab].back = newDataFormatted.back
              this.dataTabFormatted[tab].next = newDataFormatted.next
            }
          }
          else {
            this.dataTabFormatted[tab] = newDataFormatted
            if(this.dataTabFormatted[tab].isHaveData && !this.listTabHaveData.includes(tab)) {
              this.listTabHaveData.push(tab)
            }
          }
        })
      tab == 'tube_feeding' ? this.formatTubeFeedingTable() : null
    },
    getInsulinUnit(data, index = null) {
      return getHomecareInsulinUnit(data, index)
    },
    formatDataTab(tab) {
      if(this[tab].data.length == 0) {
        return {
          back: this[tab].back || false,
          isHaveData: false,
          next: this[tab].next || false,
          isEmpty: this[tab]['is_empty'] || false
        }
      }
      let result = {}
      let itemAnswer = null
      if(this[tab].data && this[tab].data.length > 0) {
        result['date'] = convertToJPTime(this[tab].data[0].answer_date_time)
        result['answer_date_time'] = this[tab].data[0].answer_date_time
        this[tab].data.forEach(item => {
          itemAnswer = JSON.parse(item.answer)
          if(item.item_name.includes('attach_images')) {
            result[item.item_name] = itemAnswer.length > 0 ? itemAnswer.map(item => item.access_url) : null
          }
          else if(itemAnswer.length > 1) {
            result[item.item_name] = itemAnswer.map(item => item.answer_value)
          }
          else {
            result[item.item_name] = (itemAnswer[0] || itemAnswer[0] == 0) ? itemAnswer[0].answer_value : null
          }
        })
      }
      result['isHaveData'] = true
      result['back'] = this[tab].back || false
      result['next'] = this[tab].next || false
      return result
    },
    onSlideStart(slide) {
      this.sliding = true
    },
    onSlideEnd(slide, maxSlide) {
      this.sliding = false
      let currentSlide = this.slide + 1;
      let btnPrev = document.querySelectorAll(".carousel-control-prev")[0]
      let btnNext = document.querySelectorAll(".carousel-control-next")[0]
      if(currentSlide === maxSlide){
        btnNext.style.display = "none"
        btnPrev.style.display = 'block'
      }
      else if(currentSlide === 1){
        btnPrev.style.display = "none"
        btnNext.style.display = "block"
      }
      else {
        btnNext.style.display = 'block'
        btnPrev.style.display = 'block'
      }
    },
    async openModalListImage(listImg, index) {
      this.slide = index
      this.dataPopup = listImg
      await this.$bvModal.show('list-image-home-care')
      // handle show/hide modal arrow when open modal
      if(index > 0) {
        document.querySelectorAll(".carousel-control-prev")[0].style.display = 'block'
      }
      if(listImg.length != 1 && index >= listImg.length - 1) {
        document.querySelectorAll(".carousel-control-next")[0].style.display = 'none'
      }
    },
    closeModalListImage() {
      this.$bvModal.hide('list-image-home-care')
    },
    convertCalculateUnit(value, flg) {
      if (flg == '*') {
        return parseFloat((value * 10).toFixed(13))
      } else {
        return parseFloat((value / 10).toFixed(13))
      }
    }
  }
}
</script>
<style scoped>
  img[lazy=loading] {
    height: 150px !important;
    margin-top: 75px;
  }
</style>
